import { tracking } from '@iwoca/frontend-tracking-library';

import { getRuntimeEnvironment } from '@src/utils/getRuntimeEnvironment';

export const initialiseTracking = () => {
    const runtimeEnvironment = getRuntimeEnvironment();

    // TODO: Remove the API key and use it as a secret key
    const AMPLITUDE_API_KEY =
        runtimeEnvironment === 'production'
            ? 'c8deac245de40e642fe0dbb2bbb0d2d2'
            : '064ff9e1580c5525bd401a4c516c5a17';

    tracking.initialise({
        environment:
            runtimeEnvironment === 'production' ? 'production' : 'development',
        clientConfiguration: {
            // @ts-expect-error
            apiKey: AMPLITUDE_API_KEY,
            defaultTracking: {
                pageViews: {
                    trackHistoryChanges: 'all'
                },
                sessions: true
            }
        }
    });
};
